export const getCurrentUserData = () => {
    const data = localStorage.getItem('userData');
    return data ? JSON.parse(data) : {};
}


export const setCurrentUserData = (data) => {
    localStorage.setItem('userData', JSON.stringify(data));
}